import Swiper, { Autoplay } from 'swiper';

if (document.querySelector('.trust-slider')) {
    const trustSliders = document.querySelectorAll('.trust-slider');

    trustSliders.forEach((trustSlider, index) => {
        const swiperContainer = trustSlider.querySelector('.swiper');

        if (swiperContainer) {
            const checkIndex = index % 2 !== 0;
            
            const swiper = new Swiper(swiperContainer, {
                modules: [Autoplay],
                loop: true,
                speed: 700,
                spaceBetween: 80,
                slidesPerView: 2,
                noSwiping: true,
                draggable: false,
                simulateTouch: false,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                },
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    reverseDirection: checkIndex,

                },
            });
        }
    });
}
